export const ENABLED_IN = {
    all: "all",
    funds: "funds",
};

export const FEES_SUPPORTED_BY = {
    owner: "owner",
    contributor: "contributor",
};
